<template>
  <div class="icon-container">
    <i class="iconfont" :class="finalFontName" @click="handleClick"></i>
  </div>
</template>

<script>
const fontNameMaps = {
  warn: "icon-warning",
  error: "icon-closed",
  success: "icon-success",
  info: "icon-information1",
  hamburger: "icon-Hamburgermenucopy",
  toTop: "icon-arrow-to-top",
  search: "icon-search",
  arrowDown: "icon-arrowdown",
  arrowUp: "icon-arrowup",
  close: "icon-close",
  email: "icon-email",
  tel: "icon-telephone",
  address: "icon-address",
  twitter: "icon-tuite",
  tiktok: "icon-tiktok",
  youtube: "icon-Youtube",
  ins: "icon-instagram",
  facebook: "icon-facebook",
  videoPlay: "icon-play",
  videoPause: "icon-pause",
  communication: "icon-duijie--",
  certificate: "icon-certificate",
  handshake: "icon-xietong",
  factory: "icon-header-16",
  "ce-cert": "icon-method-draw-image",
  "iso-cert": "icon-faguoshejijiang",
  tech: 'icon-technology',
  emergency: 'icon-emergency',
  bridge: 'icon-ConnectionsFilled'
};
const keys = Object.keys(fontNameMaps);
export { keys };
export default {
  props: {
    fontName: {
      type: String,
      required: true,
    },
  },
  computed: {
    finalFontName() {
      return fontNameMaps[this.fontName];
    },
  },
  methods: {
    handleClick() {
      this.$emit("click", this.fontName);
    },
  },
};
</script>

<style lang="less" scoped>
@import "//at.alicdn.com/t/c/font_4895079_0zr2p4fqhf6.css";
.iconfont {
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
  cursor: pointer;
}
</style>
